import { Plugin } from '@nuxt/types';
import getAbilitiesForUserType from '~/abilities/getAbilitiesForUserType';

const caslPlugin: Plugin = ({ store }, inject) => {
  const ability = getAbilitiesForUserType(store.getters['auth/userType']);
  inject('ability', ability);

  store.subscribe((mutation, state) => {
    const userType = state.auth?.me?.user?.type;

    if (mutation.type === 'auth/SET_ME' || mutation.type === 'auth/PATCH_ME') {
      ability.update(getAbilitiesForUserType(userType).rules);
    }
  });
};

export default caslPlugin;
